import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, MediaUpload, InspectorControls, URLInput } from '@wordpress/blockEditor';
import { PanelBody, ToggleControl, ColorPalette, BaseControl, Button, RangeControl, TextControl } from '@wordpress/components';

export default function Edit({ attributes, setAttributes }) {
    const { id_titre_1Texte, id_titre_1CouleurTexte, id_titre_1Opacite, id_titre_1Afficher, id_paragraphe_1Texte, id_paragraphe_1CouleurTexte, id_paragraphe_1Opacite, id_paragraphe_1Afficher, id_paragraphe_2Texte, id_paragraphe_2CouleurTexte, id_paragraphe_2Opacite, id_paragraphe_2Afficher, id_image_1Url, id_image_1Id, id_image_1Alt, id_image_1Opacite, id_image_1Afficher, blocCouleurFond, blocCouleurBordure, blocImageFondUrl, blocImageFondId, animCode } = attributes;

    // Construire le style du bloc avec image de fond en priorité
    const blocStyle = blocImageFondUrl 
        ? { 
            backgroundImage: `url(${blocImageFondUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderColor: blocCouleurBordure
        }
        : { 
            backgroundColor: blocCouleurFond, 
            borderColor: blocCouleurBordure 
        };

    const blockProps = useBlockProps({
        style: blocStyle
    });

    return (
        <>
            <style>{``}</style>
            {/* BARRE LATÉRALE (INSPECTOR) */}
            <InspectorControls>

                <PanelBody title="Bloc Principal" initialOpen={true}>
                    <BaseControl label="Image de fond">
                        <MediaUpload
                            onSelect={(media) => setAttributes({ blocImageFondUrl: media.url, blocImageFondId: media.id })}
                            type="image"
                            value={blocImageFondId}
                            render={({ open }) => (
                                <div>
                                    {blocImageFondUrl ? (
                                        <div>
                                            <img src={blocImageFondUrl} style={{ maxWidth: '100%', marginBottom: '10px' }} />
                                            <Button 
                                                variant="secondary" 
                                                isDestructive
                                                onClick={() => setAttributes({ blocImageFondUrl: '', blocImageFondId: 0 })}>
                                                Supprimer l'image
                                            </Button>
                                        </div>
                                    ) : (
                                        <Button variant="primary" onClick={open}>
                                            Choisir une image de fond
                                        </Button>
                                    )}
                                </div>
                            )}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de fond (fallback)" help="Utilisée si aucune image n'est définie">
                        <ColorPalette
                            value={blocCouleurFond}
                            onChange={(val) => setAttributes({ blocCouleurFond: val })}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette
                            value={blocCouleurBordure}
                            onChange={(val) => setAttributes({ blocCouleurBordure: val })}
                        />
                    </BaseControl>
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-2 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_paragraphe_2Afficher}
                        onChange={(val) => setAttributes({ id_paragraphe_2Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_paragraphe_2CouleurTexte}
                            onChange={(val) => setAttributes({ id_paragraphe_2CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_paragraphe_2Opacite}
                        onChange={(val) => setAttributes({ id_paragraphe_2Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="image-1 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_image_1Afficher}
                        onChange={(val) => setAttributes({ id_image_1Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_image_1Alt}
                            onChange={(val) => setAttributes({ id_image_1Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_image_1Opacite}
                        onChange={(val) => setAttributes({ id_image_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Animations" initialOpen={false}>
                    <BaseControl 
                        label="Code d'animation" 
                        help="JavaScript exécuté">
                        <textarea
                            value={animCode}
                            onChange={(e) => setAttributes({ animCode: e.target.value })}
                            placeholder="Mon animation ici..."
                            rows={8}
                            style={{ width: '100%', fontFamily: 'monospace', fontSize: '12px' }}
                        />
                    </BaseControl>
                </PanelBody>
            </InspectorControls>

            {/* VISUEL PRINCIPAL */}
            <section { ...blockProps }>
                {/* id_bloc */}
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            {/* id_titre_1 */}
                            {id_titre_1Afficher && (
                                <RichText 
                                    tagName="h1" 
                                    className="id_titre_1 " 
                                    value={id_titre_1Texte} 
                                    onChange={(val) => setAttributes({ id_titre_1Texte: val })} 
                                    placeholder="Saisir le texte..." 
                                    style={{ color: id_titre_1CouleurTexte, opacity: id_titre_1Opacite }} 
                                />
                            )}
                            {/* end-id_titre_1 */}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            {/* id_paragraphe_1 */}
                            {id_paragraphe_1Afficher && (
                                <RichText 
                                    tagName="p" 
                                    className="id_paragraphe_1 " 
                                    value={id_paragraphe_1Texte} 
                                    onChange={(val) => setAttributes({ id_paragraphe_1Texte: val })} 
                                    placeholder="Saisir le texte..." 
                                    style={{ color: id_paragraphe_1CouleurTexte, opacity: id_paragraphe_1Opacite }} 
                                />
                            )}
                            {/* end-id_paragraphe_1 */}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            {/* id_paragraphe_2 */}
                            {id_paragraphe_2Afficher && (
                                <RichText 
                                    tagName="p" 
                                    className="id_paragraphe_2 " 
                                    value={id_paragraphe_2Texte} 
                                    onChange={(val) => setAttributes({ id_paragraphe_2Texte: val })} 
                                    placeholder="Saisir le texte..." 
                                    style={{ color: id_paragraphe_2CouleurTexte, opacity: id_paragraphe_2Opacite }} 
                                />
                            )}
                            {/* end-id_paragraphe_2 */}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-5">
                            {/* id_image_1 */}
                            {id_image_1Afficher && (
                                <MediaUpload
                                    onSelect={(media) => setAttributes({ id_image_1Url: media.url, id_image_1Id: media.id })}
                                    type="image"
                                    value={id_image_1Id}
                                    render={({ open }) => (
                                        <div onClick={open} style={{ cursor: 'pointer' }}>
                                            {id_image_1Url ? (
                                                <img className="id_image_1" src={id_image_1Url} alt={id_image_1Alt} style={{ opacity: id_image_1Opacite }} />
                                            ) : (
                                                <Button variant="secondary">Ajouter une image</Button>
                                            )}
                                        </div>
                                    )}
                                />
                            )}
                            {/* end-id_image_1 */}
                        </div>
                        <div className="col-lg-7">
                            {/* id_point_1 */}
                            <div>
                                {/* id_point_1_icon_1 */}
                                <img id="id_point_1_icon_1" src="attribut_id_point_1_icon_1_src" alt="attribut_id_point_1_icon_1_alt" />
                                {/* end-id_point_1_icon_1 */}
                                {/* id_point_1_paragraphe_1 */}
                                <p id="id_point_1_paragraphe_1">
attribut_id_point_1_paragraphe_1_texte
                                </p>
                                {/* end-id_point_1_paragraphe_1 */}
                            </div>
                            {/* end-id_point_1 */}
                            {/* id_point_2 */}
                            <div>
                                {/* id_point_2_icon_1 */}
                                <img id="id_point_2_icon_1" src="attribut_id_point_2_icon_1_src" alt="attribut_id_point_2_icon_1_alt" />
                                {/* end-id_point_2_icon_1 */}
                                {/* id_point_2_paragraphe_1 */}
                                <p id="id_point_2_paragraphe_1">
attribut_id_point_2_paragraphe_1_texte
                                </p>
                                {/* end-id_point_2_paragraphe_1 */}
                            </div>
                            {/* end-id_point_2 */}
                            {/* id_point_3 */}
                            <div>
                                {/* id_point_3_icon_1 */}
                                <img id="id_point_3_icon_1" src="attribut_id_point_3_icon_1_src" alt="attribut_id_point_3_icon_1_alt" />
                                {/* end-id_point_3_icon_1 */}
                                {/* id_point_3_paragraphe_1 */}
                                <p id="id_point_3_paragraphe_1">
attribut_id_point_3_paragraphe_1_texte
                                </p>
                                {/* end-id_point_3_paragraphe_1 */}
                            </div>
                            {/* end-id_point_3 */}
                            {/* id_point_4 */}
                            <div>
                                {/* id_point_4_icon_1 */}
                                <img id="id_point_4_icon_1" src="attribut_id_point_4_icon_1_src" alt="attribut_id_point_4_icon_1_alt" />
                                {/* end-id_point_4_icon_1 */}
                                {/* id_point_4_paragraphe_1 */}
                                <p id="id_point_4_paragraphe_1">
attribut_id_point_4_paragraphe_1_texte
                                </p>
                                {/* end-id_point_4_paragraphe_1 */}
                            </div>
                            {/* end-id_point_4 */}
                            {/* id_point_5 */}
                            <div>
                                {/* id_point_5_icon_1 */}
                                <img id="id_point_5_icon_1" src="attribut_id_point_5_icon_1_src" alt="attribut_id_point_5_icon_1_alt" />
                                {/* end-id_point_5_icon_1 */}
                                {/* id_point_5_paragraphe_1 */}
                                <p id="id_point_5_paragraphe_1">
attribut_id_point_5_paragraphe_1_texte
                                </p>
                                {/* end-id_point_5_paragraphe_1 */}
                            </div>
                            {/* end-id_point_5 */}
                        </div>
                    </div>
                </div>
                {/* end-id_bloc */}
            </section>
        </>
    );
}